import * as React from 'react'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { Field } from 'formik'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const inputProps = { 'data-test-id': 'description', maxLength: 255 }

export function DescriptionField() {
  return (
    <Stack>
      <Typography variant="body1" mt={1} fontSize={16}>
        Add Description
      </Typography>
      <Field
        fullWidth
        size="small"
        name="description"
        component={MuiTextFieldFormik}
        inputProps={inputProps}
      />
    </Stack>
  )
}
